import {
    useCurrentWorkspace,
    useStorageKeys,
    WorkspaceType,
} from '@gripp/shared-logic';
import {
    AssetsList,
    SelectionStatus,
    SlideAction,
    useSlideLayout,
    ViewMode,
} from '@gripp/shared-ui';
import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { useMaxHeight } from '../../shared/hooks/useMaxHeight';
import { AddonsButton } from './addonsButton';
import { AssetGroups } from './assetGroups';
import { RoutinesButton } from './routinesButton';

export const AssetComponent = () => {
  const navigate = useNavigate();
  const { assetId } = useParams();
  const { currentViewMode, onSlideChange } = useSlideLayout();
  const workspace = useCurrentWorkspace(true);
  const storageKeys = useStorageKeys();
  const { containerMaxHeight, listMaxHeight } = useMaxHeight(64, 0, 40);
  const [selectionStatus, setSelectionStatus] =
    useState<SelectionStatus>('idle');

  const [rowsSelected, setRowsSelected] = useState<Array<any>>();

  const onAssetClick = async (asset) => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    
    navigate(`/assets/${asset.id}`);
  };

  const updateRowsSelected = (rows: Array<any>) => {
    setRowsSelected(rows.map(row => row.id));
  };

  const resetRowSelection = () => {
    updateRowsSelected([]);
    setSelectionStatus('reset');
  };

  const AddToGroups = () => (
    <View style={styles.addToGroupsContainer}>
      <AssetGroups
        assetIds={rowsSelected}
        workspaceId={workspace?.id}
        onUpdateRowSelected={resetRowSelection}
      />
    </View>
  );

  return (
    <View
      style={[
        styles.assetsContainer,
        {
          maxHeight: containerMaxHeight,
        },
      ]}
    >
      <AssetsList
        onAssetClick={onAssetClick}
        maxHeight={listMaxHeight}
        updateRowsSelected={updateRowsSelected}
        preserveScrollKey={storageKeys.assetsScrollData}
        addToGroupsComponent={AddToGroups()}
        selectionStatus={selectionStatus}
        onSelectionStatusChange={(status) => setSelectionStatus(status)}
        routinesButton={RoutinesButton}
        addonsButton={workspace?.type === WorkspaceType.Oem ? AddonsButton : undefined}
        selectedAssetId={assetId}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  addToGroupsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  assetsContainer: {
    flex: 1,
    borderRadius: 4,
    overflow: 'hidden',
    zIndex: -1,
  },
});
